export enum ScreenType {
  fullscreen = 'fullscreen',
  tablet = 'tablet',
  phone = 'phone'
}
